import { z } from 'my-zod'
import { modelFamiliesModel } from '../../fleet-operations/model-family'

export const modelFamilyAvailabilitySystemView = modelFamiliesModel
  .pick({
    id: true,
    modelFamilyName: true,
    marketingDisplayName: true,
    productLine: true,
    seasonTypes: true,
    modelFamilyImageUrl: true,
    capacity: true,
    lastModifiedDate: true,
    deletedDate: true
  })
  .augment({
    availableQuantity: z.number()
  })

export type modelFamilyAvailabilitySystemView = z.infer<typeof modelFamilyAvailabilitySystemView>
